import React from "react";
import Error from "./common/Error";

const NotFound = props => {

    return (
        <Error errorStatus={'404'} errorText={'Page Not Found :-('} errorDescription={"We can't find the page you are trying to access!"} />
    );

};

export default NotFound;